import { createQueryStringSelector } from "selectors/queryString"
import { get } from "lodash"

const EMPTY_ARRAY = []

export const getFactorCategoryId = createQueryStringSelector("factorCategory", "total")
export const getOnly = createQueryStringSelector("only")
export const getDisabled = createQueryStringSelector("disabled", EMPTY_ARRAY)
export const getFocusedChartLine = state => get(state, "modules.analyzeCompositePerformance.focusedChartLine")
